import React from "react";
import StarRatings from "react-star-ratings";

import { Grid } from "@material-ui/core";

export default class StarWidgetReadOnly extends React.Component {
  render() {
    const { rating = 0, starDimension = "23px", showNumber } = this.props;

    if (showNumber) {
      return (
        <Grid
          item
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: "-30px",
          }}
        >
          <StarRatings
            rating={rating}
            starDimension={starDimension}
            starEmptyColor="rgb(223,224,227)"
            starRatedColor="#0caa41"
            starSpacing="2px"
            numberOfStars={5}
            style={{ marginLeft: "10px" }}
          />
          {showNumber && (
            <Grid
              item
              style={{ fontSize: "18px", marginLeft: "8px", marginTop: "-2px" }}
            >
              {rating} / 5
            </Grid>
          )}
        </Grid>
      );
    }
    return (
      <StarRatings
        rating={rating}
        starDimension={starDimension}
        starEmptyColor="rgb(223,224,227)"
        starRatedColor="#0caa41"
        starSpacing="2px"
        numberOfStars={5}
        style={{ marginLeft: "10px" }}
      />
    );
  }
}
